import { BlazeLogo } from 'components/MultiStepFlow/MultiStepPageLayout/BlazeLogo'
import Styles from './WhiteLabelLogo.module.scss'

interface WorkspaceBranding {
  is_whitelabel?: boolean
  app_logo_url?: string | null
  name?: string
}

interface Props {
  width?: number
  height?: number
  workspace?: WorkspaceBranding | null
  logoUrl?: string | null
  isWhitelabel?: boolean
  altText?: string
}

export const WhiteLabelLogo = ({
  width = 147,
  height = 42,
  workspace,
  logoUrl,
  isWhitelabel,
  altText = 'Logo',
}: Props) => {
  const showCustomLogo = workspace ? workspace.is_whitelabel && workspace.app_logo_url : isWhitelabel && logoUrl

  const customLogoUrl = workspace?.app_logo_url || logoUrl
  const alt = workspace?.name || altText

  if (showCustomLogo && customLogoUrl) {
    return (
      <img
        src={customLogoUrl}
        alt={alt}
        className={Styles.customLogo}
        style={{ maxHeight: height, maxWidth: width * 1.5 }}
      />
    )
  }

  return <BlazeLogo width={width} height={height} />
}
